import {IAuthState} from '@/interfaces/state';
import {User} from '@/interfaces/user';

export default {
  setToken: (state: IAuthState, payload: string): void => {
    state.token = payload;
  },
  setRefreshToken: (state: IAuthState, payload: string): void => {
    state.refreshToken = payload;
  },
  setUser: (state: IAuthState, payload: User): void => {
    state.user = payload;
  }
};
